import React from "react";
import styled from "styled-components";

export default styled.div`
    background: white;
    position: absolute;
    bottom: 15px;
    left: 100px;
    width: 350px;
    height: 270px;
    z-index: 20;
    display: none;
    box-shadow: 5px 5px 25px rgb(0 0 0 / 29%);

    ${(props) => (props.open ? {
    'display': 'block',
} : '')}
`;
